'use client'

import React, { memo } from 'react'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import Box from '@mui/material/Box'
import { googleMapsApiKey } from 'vars'
import sx from './styles'

const Map = ({
  location, zoomLevel, confirmationVariant, sx: sxProp,
}) => {
  const sxRoot = confirmationVariant ? sx.confirmationVariant : sx.root
  const { isLoaded } = useLoadScript({
    googleMapsApiKey,
  })

  if (!isLoaded) return <div>Loading...</div>

  return (
    <Box sx={{ ...sxRoot, ...sxProp }}>
      <GoogleMap
        center={location}
        zoom={zoomLevel}
        mapContainerStyle={{ width: '100%', height: '100%' }}
        options={{ disableDefaultUI: true, scrollwheel: false }}
      >
        <Marker position={location} />
      </GoogleMap>
    </Box>
  )
}

export default memo(Map)
